/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable import/prefer-default-export */
import React from 'react';
import {
  Space,
  Tag,
} from 'antd';
import Button from 'antd-button-color';
import 'antd-button-color/dist/css/style.css';
import moment from 'moment/moment';
import Can from '../../../util/can';
import { FDS_CARDS } from '../../../constants/resources';

export const FdsCardsColumns = (
  handleEdit,
  handleEditRecord,
  timezone,
) => {

  const offset = timezone?.offset ?? 3;

  return [
    {
      title: 'Card',
      dataIndex: 'masked_card_number',
      width: 160,
      sorter: true,
    },
    {
      title: 'Type',
      dataIndex: 'card_type',
      width: 80,
      sorter: false,
      search: false,
    },
    {
      title: 'Expiry At',
      dataIndex: 'expiry_at',
      width: 100,
      sorter: false,
      search: false,
      render: (date) => (
        <span title={date}>
          {moment(date).utc().add('hours', offset).format('MM/YYYY')}
        </span>
      ),
    },
    {
      title: 'Risk Level',
      dataIndex: 'risk_level',
      width: 100,
      sorter: false,
      search: false,
    },
    {
      title: 'Ban',
      dataIndex: 'hard_ban',
      width: 60,
      sorter: false,
      search: false,
      render: (val, record) => (
        <>
          <div>
            <Tag color={record.hard_ban ? 'green' : 'red'}>
              {record.hard_ban ? 'Yes' : 'No'}
            </Tag>
          </div>
        </>
      ),
    },
    {
      title: 'White/L',
      dataIndex: 'whitelisted',
      width: 100,
      sorter: false,
      search: false,
      render: (val, record) => (
        <>
          <div>
            <Tag color={record.whitelisted ? 'green' : 'red'}>
              {record.whitelisted ? 'Yes' : 'No'}
            </Tag>
          </div>
        </>
      ),
    },
    {
      title: 'FTD',
      dataIndex: 'is_ftd',
      search: false,
      width: 130,
      render: (val, record) => (
        <>
          <div>
            <Tag color={record.is_ftd ? 'green' : 'red'}>
              {record.is_ftd ? 'Yes' : 'No'}
            </Tag>
            <small>
              {' '}
              {' '}
              Is New ?
            </small>
          </div>
          <div>
            <Tag color={record.is_kitegateway_ftd ? 'green' : 'red'}>
              {record.is_kitegateway_ftd ? 'Yes' : 'No'}
            </Tag>
            <small>
              {' '}
              {' '}
              Is Kitegateway ?
            </small>
          </div>
        </>
      ),
    },
    {
      title: 'Fraud',
      dataIndex: 'is_kitegateway_fds',
      width: 250,
      sorter: false,
      search: false,
      render: (val, record) => (
        <>
          <div>
            <Tag color={record.is_kitegateway_fds ? 'green' : 'red'}>
              {record.is_kitegateway_fds ? 'Yes' : 'No'}
            </Tag>
            <small>
              {' '}
              {' '}
              Is Kitegateway ?
            </small>
          </div>
          <div>
            <Tag color={record.has_scheme_fraud ? 'green' : 'red'}>
              {record.has_scheme_fraud ? 'Yes' : 'No'}
            </Tag>
            <small>
              {' '}
              {' '}
              Scheme ?
            </small>
          </div>
          <div>
            <Tag color={record.has_kitegateway_scheme_fraud ? 'green' : 'red'}>
              {record.has_kitegateway_scheme_fraud ? 'Yes' : 'No'}
            </Tag>
            <small>
              {' '}
              {' '}
              Kitegateway Scheme ?
            </small>
          </div>
          <div>
            <Tag color={record.whitelist_kitegateway_scheme_fraud ? 'green' : 'red'}>
              {record.whitelist_kitegateway_scheme_fraud ? 'Yes' : 'No'}
            </Tag>
            <small>
              {' '}
              {' '}
              Whitelist Kitegateway Scheme ?
            </small>
          </div>
          <div>
            <Tag color={record.is_neutrino_fraud ? 'green' : 'red'}>
              {record.is_neutrino_fraud ? 'Yes' : 'No'}
            </Tag>
            <small>
              {' '}
              {' '}
              Neutrino ?
            </small>
          </div>
        </>
      ),
    },
    {
      title: 'P/Scheme',
      dataIndex: 'kitegateway_scheme_fraud_count',
      width: 110,
      search: false,
      sorter: false,
    },
    {
      title: 'C/Backs',
      dataIndex: 'charge_backs',
      width: 100,
      sorter: false,
      search: false,
    },
    {
      title: 'Failed',
      dataIndex: 'failed_transactions',
      width: 100,
      sorter: false,
      search: false,
    },
    {
      title: 'Refunds',
      dataIndex: 'refunds',
      width: 100,
      sorter: false,
      search: false,
    },
    {
      title: 'Success',
      dataIndex: 'successful_transactions',
      width: 100,
      sorter: false,
      search: false,
    },
    {
      title: 'First',
      dataIndex: 'first_transacted_at',
      width: 120,
      sorter: false,
      search: false,
      render: (date) => (
        <span title={date}>
          {moment(date).utc().add('hours', offset).format('DD/MM/YYYY h:mm:ss a')}
        </span>
      ),
    },
    {
      title: 'Last',
      dataIndex: 'last_transacted_at',
      width: 120,
      sorter: false,
      search: false,
      render: (date) => (
        <span title={date}>
          {moment(date).utc().add('hours', offset).format('DD/MM/YYYY h:mm:ss a')}
        </span>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      search: false,
      render: (record) => (
        <Space size="middle">
          <Can I="update" a={FDS_CARDS}>
            <Button
              data-testid={`update-record-${record._id}`}
              type="primary"
              className="ant-btn-sm ant-btn-background-ghost"
              onClick={() => {
                handleEdit(record);
                handleEditRecord(record);
              }}
            >
              <i className="icon icon-edit" />
            </Button>
          </Can>
        </Space>
      ),
    },
  ];
}
